import { HelpButton } from '@components/help/HelpButton'
import { SBAsyncSelect } from '@supplement-bacon/react-async-select'
import { Entity } from '@utils/Entities'
import { requiredRule } from '@utils/rules'
import {
  Alert,
  Button,
  Col,
  Flex,
  Form,
  Input,
  Row,
  Spin,
  Typography,
} from 'antd'
import { useEffect, useState } from 'react'
import { ExternalLink } from '../../../ExternalLink'
import { StepProps } from '../../types'
import {
  attachSeatingAreas,
  fetchSevenroomsSeatingAreaForVenue,
} from '../service'
import { ContentWrapper } from './ContentWrapper'

const { Title, Text } = Typography

export const SteatingAreasMapping = ({
  venue,
  product,
  onPrev,
  onNext,
}: StepProps) => {
  const [form] = Form.useForm()
  const [isLoading, setIsLoading] = useState<boolean>(false)

  const handleNextClicked = async () => {
    try {
      const values = await form.validateFields()
      await attachSeatingAreas(venue.slug, values)
      onNext && onNext()
    } catch (error) {
      //TODO: Handle error
    }
  }

  useEffect(() => {
    setIsLoading(true)
    fetchSevenroomsSeatingAreaForVenue(venue.slug)
      .then((result) => {
        form.setFieldValue(
          'seatingAreasAssociation',
          result.data.map((area) => ({
            sevenrooms: area.id,
            sevenroomsName: area.name,
            area: area.mappedSeatingArea,
          }))
        )
      })
      .finally(() => setIsLoading(false))
  }, [venue])

  return (
    <>
      <ContentWrapper>
        <Flex vertical gap={5}>
          <Title className="m-0" level={5}>
            Map your seating areas
          </Title>
          <Text>
            To ensure an optimal experience for your users, please map your
            Sevenrooms areas to your Seating Areas previously added to your
            account on the{' '}
            <ExternalLink
              content={'Settings page'}
              to={'/settings/booking/seating-areas'}
            />
            .
          </Text>
        </Flex>

        {isLoading && <Spin />}
        <Form form={form} layout="vertical">
          <Form.List name={'seatingAreasAssociation'}>
            {(fields) => (
              <Flex vertical gap={16}>
                {fields.map(({ key, name }) => (
                  <Row key={key} gutter={[16, 16]}>
                    <Form.Item
                      noStyle
                      hidden
                      name={[name, 'sevenrooms']}
                      rules={[requiredRule()]}
                    >
                      <Input hidden />
                    </Form.Item>
                    <Col span={12}>
                      <Form.Item
                        name={[name, 'sevenroomsName']}
                        rules={[requiredRule()]}
                        label={'Sevenrooms area'}
                      >
                        <Input disabled />
                      </Form.Item>
                    </Col>
                    <Col span={12}>
                      <Form.Item
                        name={[name, 'area']}
                        rules={[requiredRule()]}
                        label={'Area'}
                      >
                        <SBAsyncSelect entity={Entity.seatingArea} />
                      </Form.Item>
                    </Col>
                  </Row>
                ))}
              </Flex>
            )}
          </Form.List>
        </Form>

        <Alert
          title={`For more information about the purpose and the benefits of areas mapping, you can read our documentation by clicking here.`}
          type="info"
          action={<HelpButton articleId="31" />}
        />
      </ContentWrapper>
      <Flex justify="flex-end" gap={8}>
        <Button onClick={onPrev}>Previous</Button>
        <Button type="primary" loading={isLoading} onClick={handleNextClicked}>
          Next
        </Button>
      </Flex>
    </>
  )
}
